import { render, staticRenderFns } from "./order-index.vue?vue&type=template&id=dc0c7722&scoped=true"
import script from "./order-index.vue?vue&type=script&lang=js"
export * from "./order-index.vue?vue&type=script&lang=js"
import style0 from "./order-index.vue?vue&type=style&index=0&id=dc0c7722&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc0c7722",
  null
  
)

export default component.exports